import { useRevalidator } from '@remix-run/react';
import { clsx } from 'clsx';
import { type SupportedCurrency } from '#common/config/currencies';

interface Props {
    currency: SupportedCurrency;
    availableCurrencies: SupportedCurrency[];
    className?: string;
}

export function CurrencySwitcher({ currency, availableCurrencies, className }: Props) {
    const revalidator = useRevalidator();

    if (availableCurrencies.length <= 1) {
        return null;
    }

    const setCurrency = (c: SupportedCurrency) => {
        document.cookie = `preferred_currency=${c};path=/;max-age=${60 * 60 * 24 * 365};SameSite=Lax`;
        revalidator.revalidate();
    };

    return (
        <div className={clsx('flex items-center gap-1 text-sm', className)}>
            {availableCurrencies.map((c, i) => (
                <span key={c}>
                    {i > 0 && <span className='mx-0.5'>|</span>}
                    <button
                        type='button'
                        onClick={() => setCurrency(c)}
                        className={clsx(
                            'hover:opacity-75 cursor-pointer',
                            c === currency ? 'font-bold underline' : 'opacity-70'
                        )}
                    >
                        {c}
                    </button>
                </span>
            ))}
        </div>
    );
}
